import React from 'react';

const DeleteConfirmationModal = ({ isOpen, onClose, onConfirm, admin }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-96">
        <h2 className="text-xl font-bold mb-4">Delete Confirmation</h2>
        <p>
          Are you sure you want to delete{' '}
          <span className="font-bold">{admin?.firstName} {admin?.lastName}</span>?
        </p>
        <div className="flex justify-end mt-4">
          <button
            className="bg-gray-300 text-gray-800 px-4 py-2 rounded mr-2"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="bg-red-600 text-white px-4 py-2 rounded"
            onClick={onConfirm}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;
